export default {
  getListaDespesasImportacao(state) {
    return state.listaDespesasImportacao;
  },
  getHeaders(state) {
    return state.headers;
  },
  getFiltros(state) {
    return state.filtros;
  },
};
